/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */

export const sumArrayValues = (array: number[]): number =>
  array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

export const objToArray = <K extends string | number, V>(object: { [key in K]: V } = {} as { [key in K]: V }): [K, V][] =>
  Object.entries(object) as [K, V][];

export const typedObjectValues = <T extends string | number | symbol, J>(obj: { [key in T]: J }): J[] => Object.values(obj) as J[];

interface SplitArrayIntoRowsParams<T> {
  items: T[];
  maxSize?: number;
}

export const splitArrayIntoRows = <T>({ items = [], maxSize = 2 }: SplitArrayIntoRowsParams<T>): T[][] => {
  // Maximum number of items per row
  const chunkSize = items.length > maxSize ? Math.floor(items.length / 2) : items.length;
  return items.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / chunkSize);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new row
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, [] as T[][]);
};